import { ReactNode } from 'react'
import './DetailsModal.css'

interface DetailsModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  children: ReactNode
  actions?: ReactNode
}

export function DetailsModal({ isOpen, onClose, title, children, actions }: DetailsModalProps) {
  if (!isOpen) return null

  return (
    <div className="details-modal-overlay" onClick={onClose}>
      <div className="details-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="details-modal-header">
          <h2>{title}</h2>
          <button className="details-modal-close" onClick={onClose} title="Zavřít">
            ×
          </button>
        </div>
        <div className="details-modal-body">
          {children}
        </div>
        {actions && (
          <div className="details-modal-footer">
            {actions}
          </div>
        )}
      </div>
    </div>
  )
}

export default DetailsModal

